
import Vue from 'vue'
import { VIcon } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcBooleanIcons',
  components: { VIcon },
  props: {
    value: {
      type: [Boolean, String],
      default: null,
      validator: (prop: boolean | string) =>
        [true, false, 'Y', 'N', 'Yes', 'No', null].includes(prop),
    },
  },
})
